<script>
export default {
  props: ['do'],
  mounted() {
    const listener = (e) => {
      if (e.target === this.$el || this.$el.contains(e.target)) {
        return;
      }
      this.do(e);
    };
    const handleEscapePress = (e) => {
      if (e.key == 'Escape') {
        this.do(e);
      }
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('keydown', handleEscapePress);
    this.$once('hook:beforeDestroy', () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('keydown', handleEscapePress);
      console.log('on click unmounted');
    });
  },
  render() {
    return this.$slots.default[0];
  },
};
</script>



// WEBPACK FOOTER //
// OnClickOutside.vue?bcefc878